import { render, staticRenderFns } from "./WaveformSelectInput.vue?vue&type=template&id=5b35c1fb&scoped=true&"
import script from "./WaveformSelectInput.vue?vue&type=script&lang=js&"
export * from "./WaveformSelectInput.vue?vue&type=script&lang=js&"
import style0 from "./WaveformSelectInput.vue?vue&type=style&index=0&id=5b35c1fb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35c1fb",
  null
  
)

export default component.exports